module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-two"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }), _c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("he afternoon French Quarter tour wound up being a long one. They always allowed for questions after the tour, and it turned out they had a lot of people with questions. When they finished, Julian decided to head home, but Nikki wanted to do some shopping, so she and Andy headed off.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" In addition to suggesting the party, Max had given Nikki a bonus. There was a corset shop on Royal Street and a certain piece of clothing she had been coveting for quite a while. On the way they stopped by Andy’s place to check on an old woman, Mrs. Montobello, Andy seemed to have adopted. The woman was full of tales about her younger years in New Orleans. She was an Italian immigrant who’d come to marry a fellow Italian, sight unseen, but now her husband was long gone, her one son had also passed away, and her grandchildren were sweet but living their own lives in New York City.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" That day, she was on a kick about the many voodoo queens, and tarot and palm readers in the French Quarter.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “All shysters,” she said, shaking her old gray head with animation. “Once upon a time voodoo was a way for the slaves to have something of their own—and to get back at their masters, eh? But I can tell you this—there were women once who really had a special gift.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Mrs. Montobello,” Nikki said, “Marie Laveau supported her ‘powers’ by eavesdropping.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Dear child,” Mrs. Montobello protested. “Don’t you go doubting things just because they can’t be seen. I hear that you give the best ghost tour out there. That people believe they’ve seen ghosts when they get back from a walk with you. That’s because you see them, don’t you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nikki shook her head. “I think it’s just a matter of seeing history, feeling the emotions that must have played out. But I’m a girl who sees the real picture. We lead tours, we make money. I don’t fall for the shyster palm readers. Oh, I believe there are people who give ‘good’ readings, but I think that’s because they would have made fabulous psychologists. They know how to read people.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Nikki’s good. No matter what she says, I’ve stood next to her and felt chills,” Andy said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “So you really do talk to ghosts, huh?” Mrs. Montobello said, rheumy blue eyes studying Nikki in far too serious a manner.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No. I have a feel for history, and I think I’m a good story-teller,” Nikki said. “I do not talk to ghosts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “So you don’t talk to them, but do they talk to you?” Mrs. Montobello asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Good heavens, no!” Nikki said. “I’d have a heart attack on the spot if that happened. And if they’re out there,” Nikki said mischievously, “they apparently know that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Maybe they will talk to you one day,” Mrs. Montobello murmured. “I suppose, just like plain folk, ghosts need to have something to say. But you believe they’re out there—I can tell.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nikki felt a sudden chill. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yes, she believed in ghosts, or if not ghosts, per se, in a memory that lingered in certain places.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It sure as hell wasn’t something she was going to share with anyone.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Not even Mrs. Montobello.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “At my age,” the old woman said, “you come to know a difference in this world, perhaps because you’re so close to the next.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She was still studying Nikki closely. Nikki found herself staring back for a long moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" For a moment she found herself thinking, I ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("can")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" see a fog. And I can feel the cold, an essence, a feeling… when someone is lost, when they’re frustrated. Looking for something. They’re benign, meaning no harm, and they are no more than mist, something in my heart, or imagination.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Then she shook off the feeling, and they continued to chat as Nikki and Andy picked up the tea they had made for Mrs. Montobello, washed and dried and straightened, and then headed out.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" At the door, Mrs. Montobello stared at Nikki strangely again. “Go shopping. Listen to the music. But stay away from shysters.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As they walked along the streets, past neon lights, garish come-ons, charming boutiques, and bars and clubs that wailed with blues and pop and everything in between, Andy suddenly stopped. “Isn’t it funny? I feel like a little kid. Mrs. Montobello just said we shouldn’t stop by a voodoo shop, so now I’m itching for a palm reading.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Andy, come on, they’re just silly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Okay, how about a tarot card reading?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nikki hesitated, staring at her. “Just let me buy that corset I want and I’ll take you to a good place.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yeah?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We won’t tell Mrs. Montobello.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nikki liked the boutique where she purchased the corset. Everything was unique and handmade. But since Andy seemed restless, she didn’t take the time to look around, just made her purchase, and then they headed for Conte Street.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The name of the place was Contessa Moodoo’s Hoodoo Voodoo. Not promising, Nikki admitted as Andy stared at her, but she knew the woman who owned the shop fairly well. She was large, of mixed ancestry, African, Native American, white…maybe even some Asian, and whatever her real name might have been, she didn’t use it. She just went by Contessa. She had long ago told Nikki that her potions were just what they said on the bottles—vitamins, with maybe a few herbs thrown in. And in her readings…well, she told people what they wanted to hear.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" After purchasing a love potion, a bottle of vitamin E and a few sachets, Nikki introduced Andy.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And,” she said, “my friend wants a reading.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Contessa had remarkable eyes, like marbles, so many colors it would be hard to describe them in any customary way. Hazel was the best Nikki could summon, but they sometimes looked almost blue, sometimes gray, and sometimes they seemed very dark and mysterious.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She stared at Andy with a shrug. “Come on, then.” Contessa had a little nook, filled with the pleasant scent of incense, and blocked off from the rest of the room by a bead curtain. They walked by voodoo dolls, more potions and curios to reach it.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Contessa took a seat behind a table with a beautiful crystal ball in the middle—she had long ago told Nikki it was just for looks. She indicated that Andy should take the chair opposite her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She picked up her deck of cards and asked Andy to hold them. Then she took them and dealt them out.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But as she flipped the first over, she paused. Andy touched a card, and this time, Contessa swept up the deck, shaking her head. “The cards aren’t talking tonight, I’m sorry,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nikki stared at her, puzzled. She brought people here because she knew that Contessa would find something uplifting to say to her clients. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A decision looms before you, think long and carefully.")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Or ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("There has been a division of sorts in your life and you must consider the past and remember that forgiveness is something we all must feel, if we are to be happy with ourselves.")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Or even, ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The future is bright, go for it.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Okay, how about a palm reading?” Andy suggested.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Contessa stiffened, lowering her head. Nikki saw Andy smile, as if she were applauding the act. But Nikki knew this was no act.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" With a sigh, Contessa held Andy’s palm, looking very serious. At last she looked up at her. “You be careful, young woman. Very careful.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Why?” Andy demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “When you’re home, you lock yourself in. Don’t go talking to no strangers. And…”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And?” Andy demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “There’s something…” Contessa muttered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Oh,” Andy said lightly. “I lived a pretty hard life for a while. Drugs,” she admitted. “But I’m clean as a whistle now. Honestly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You lock your doors,” Contessa said. “And you keep away from those no-accounts, you hear?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes, ma’am. And thank you. What else? Am I going to fall in love?” Andy demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Contessa kept her strange mottled eyes on Andy; she didn’t look at her hand again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We all fall in love, don’t we?” she asked. Then she added, “Okay, shoo, now. Off you go. And keep those doors locked!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nikki was surprised when Contessa all but hustled them out the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “But I didn’t pay you!” Andy protested.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Honey, you don’t owe me a thing. Now git. There’s a world out there to be lived. You go live it quick.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The door closed behind them with a soft ringing of bells.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Andy burst into laughter. “Well, you and Mrs. Montobello are right. She sounds more like a mother than a psychologist. Go home, lock your doors. Watch out for strangers. Well, she was fun, anyway. Thanks, Nikki.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nikki nodded, not knowing why she was feeling disturbed when Andy was amused.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Strange, though, huh? I’ll bet she could tell I’d been a junkie once upon a time.” Andy sighed. “Hey…you don’t think, if Max knew about my past, that he’d fire me, do you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No. And who knows about Max’s past, anyway?” Nikki joked. Then she turned serious. “Andy, you had a hard life, but you’ve risen above it. Contessa gave you good advice. Watch out for anyone who might want to drag you down again. That’s it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She warned me to watch out for strangers. Let me tell you, there were some damn strange people in my past, that’s for sure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “So leave them in the past.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yeah, well…sometimes I wonder if they’ll come back to haunt me, no matter where I leave them.” She hesitated. “Did you ever smoke, Nikki?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Smoke…you mean cigarettes?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Andy laughed. “Yes, I meant cigarettes!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “In high school and college. Then I quit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yeah, but were you ever really addicted?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You bet. I went to a hypnotist, and I chewed the gum like crazy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “They say cigarettes are the hardest addiction to break,” Andy said. “But you know how it is. You quit smoking—you may have given it up for years—but sometimes you’ll see someone with a cigarette, and you just want one so badly you can barely stand it. But you know you can’t have that one cigarette because you’ll wind up with the addiction all over again, no matter what you tell yourself. Do you know what I’m saying?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes, I know I can’t have one cigarette.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It’s like that with other stuff… Every once in a while, you think, man, I’d love to have that high, just one more time. But you know you can’t do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You’re not afraid you’ll be tempted, are you?” Nikki asked her, worried.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Andy shook her head. “No. Because I know what could happen. And I’ve seen far too many lives destroyed. I’m straight as an arrow now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Good for you,” Nikki said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And I love my job.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “That’s great. Hey!” Nikki said suddenly. She lowered her voice. “Speaking of drugs and addictions… look.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “There’s that guy again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What guy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The one we saw today, at Madame D’Orso’s.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Andy turned, looking across Conte. There was a crowd around the popular bar on the corner, which was supposedly haunted by a cool jazz guitarist. “Where?” she demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Right there. Great. I gave him a twenty, and he used it to go drinking,” Nikki said in disgust.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I don’t see him,” Andy said, craning her neck and frowning.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “There…right there.” Nikki pointed. The man was there, staring straight at her. He still looked as if he longed to reach out, touch her…talk to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Then the crowd moved. People laughing, talking. A sad trumpet lament began to play. And he was gone.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Well, go figure. No more twenties to junkies, huh?” Andy said. She walked on.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" And Nikki followed, trying to shake off the sudden chill that seemed to wash over her like ice from a not-so-distant past.")])]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Another day.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Another corpse.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A junkie, lying beneath one of the highway overpasses, nearly covered by newspapers and other debris, needle by his side.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Detective Owen Massey and his partner had been called in after the patrol cops had cordoned off the scene. The ME had arrived, too, and agreed that this was just another life wasted, tragic but simple.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Not dead too long. At least the poor sucker hadn’t rotted and decayed like a misbegotten rat. By the ME’s estimation, this particular John Doe had only been a goner for a matter of hours. Cause of death seemed obvious. Heroin overdose.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nearly quitting time, and he was tired. He loved the French Quarter like he might his child, if he’d ever had one. But there were days…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A few more lines to fill in, and he could go home, he thought, sitting at his desk.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Massey had nearly finished with the paperwork—not a homicide, death by misadventure—when his partner came striding across the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hold the presses,” Marc Joulette said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You got an ID?” Massey asked. “A match on the prints?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yeah. Tom Garfield. FBI. Under cover for the last three months.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “FBI,” Joulette repeated.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Massey groaned, nearly letting his head fall on the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It would be one hell of a long time before he’d be going home that night.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The feds will be sending someone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Oh, great.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He let his head crash to the desk.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" No one noticed. A bunch of uniforms were heading out, talking as they went.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Massey looked up, frowning. “Politics,” Joulette told him. “Going to provide security for some rally.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Massey arched both brows. Joulette shrugged. “It’s a hot race for that senate seat,” he explained. “I haven’t seen this much activity in a coon’s age.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Politics. In Louisiana. There’s a cesspool for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hey!” Joulette protested. “There are a lot of good guys out there, trying to make a difference. Not to mention right here in the department.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Actually, Massey agreed. There were plenty of good men in the department. And he hated the fact that Louisiana politics had too often been on the shady side. It was a good state. He loved New Orleans with a passion. He shrugged. “Problem is, no two guys seem to have the same opinion when it comes to what constitutes the greater good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Well, we’re not politicians. We’re cops. And we’ve got a dead fed on our hands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Right,” Massey said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hey, Massey, Joulette.” It was Robinson, a street cop who had spent some time in forensics.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What’s up?” Joulette asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Purse snatcher,” Robinson said. Young and wiry, he was a good cop, capable of running down perps who were convinced they could outrun any of the parish’s beignet-eaters.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Massey cleared his throat. “Um…wrong fellow to get after a purse snatcher,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Robinson grinned. “Hey, I know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You mean you didn’t run the guy down?” Joulette asked him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Naw, I got the call too late.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “So…?” Massey prompted.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “This is just curious. Maybe nothing. But I thought that I’d show you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Robinson produced the small sketchbook he’d been carrying. He was a good artist, and the sketch he’d produced appeared to be a likeness of Tom Garfield, their dead FBI agent.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Frowning, Massey stared hard at the picture. “What’s this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The woman whose purse was snatched told me that she never saw the man who swiped her bag, but she said she’d seen a suspicious-looking down-and-outer right before it happened. On Bourbon Street. I asked her to describe the guy. And this is what I got. A picture of your corpse.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Robinson, you’ve seen the pictures of Garfield. You just drew him ’cause those images were in your mind,” Joulette said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No. The woman told me this was the guy she saw—to a T.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Couldn’t have been. If this purse snatching just happened, Garfield was already dead,” Massey said more gently. He liked Robinson.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The woman swears up and down that this is who she saw.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “So our fed is dead but snatching purses?” Joulette scoffed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Maybe he’s got a look-alike running around the city, that’s what I’m suggesting,” Robinson said. “Who knows how or why, but it could mean something. I just thought you two should know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Did you show the boss?” Massey asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Robinson nodded. “Weird, huh?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Thanks,” Massey told him. “Hey, can I keep the sketch?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’ll make you a copy,” Robinson assured him. “The boss already has one.” He gave Joulette an aggravated stare and moved on.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Everybody’s just got to get in on the act, huh?” Joulette said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Massey shook his head. Robinson was a bright officer, and the sketch was disturbing.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He sighed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It was going to be a hell of a long night.")])]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Brent Blackhawk fought the dream, because he knew what the dream meant. But it was too strong for him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" First there was the mist.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Then there was his grandfather.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Finally he was back on the day when they had gone to the battlefield where Custer had made his last stand. Where the combined forces of many tribes had conquered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As a child, he had seen them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" There had been awful moments when he had felt sheer terror. He had seen the soldiers and the warriors. Heard the savage war cries. The shouts of the cavalry.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The cries for mercy.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He had seen the agony and fear, tasted the acrid scent of gunpowder.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He had kept silent, had not corrected the tour guide. It would be wrong for a little boy to correct his elders, even though he knew what they did not. He had listened to the tours; he had gone to the encampments. He had sat with his grandfather in a sweat lodge, and the old men and the younger ones had discussed how Custer’s last stand had in reality been the last stand of the American Indian.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Later his grandfather had talked to him. He had known.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It’s all right,” he had assured him. “It’s all right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Is it because I’m a quarter Indian?” he had asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" And his grandfather had taken him into his arms. “Well, boy, I don’t know. Your mom, now, she was what they called a truly lovely lass from the old country. And her people are known for being what they call a bit ‘fey.’ What matters is that you have a gift, and you have it for a reason. Perhaps in time you’ll see that it’s not frightening, and you’ll know why it’s been given to you. And that it’s good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Sometimes, he still wondered when the “good” would kick in. He had learned to use it, just as a policeman learned to use his weapon. There were times when he knew that his help changed lives, even made them bearable again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But as for himself…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" In the dream, he groaned.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s time again,")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" his grandfather told him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I know,")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" he replied. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I’ve felt it coming.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His grandfather nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" So they stood together again in that valley near the Black Hills, and the mist began to swirl around them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Those who thought that native peoples were stoic, that they did not show their emotions, were wrong. He felt, in the deep recesses of the dream, the love that came to him through time, through space. Through the darkest boundary of death.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He woke. And when he did, he sighed, looking at the rays of sun that streaked through his bedroom window.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nothing to do about it. Go along with his life as it had been planned.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" When he was needed, Adam would find him.")])]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Nikki awoke in the morning, feeling oddly exhausted.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She felt as if she had barely slept at all, and she knew it was because she had tossed and turned in a series of weird nightmares.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She couldn’t remember her dreams; she just had the lingering sense of having spent the night in a whirl of very strange sensation. It left her with an odd feeling.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A foreboding.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Oh, man!")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She tried to shake it off. It was a beautiful morning. The sun…she could just see it peeking in through her drapes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She rose, thinking it must have been the conversation with Mrs. Montobello and then Contessa’s reading.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" This sense of unease wasn’t something she usually felt. Even when the “ghosts” were around. The ghosts were benign…faint indentations upon the present that simply lingered. There was a sweet nostalgia to what she saw and felt, something that made her feel even more affectionate toward her home, reassured her that New Orleans was special.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But there had been something about the dreams last night. Something…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Something that was malignant rather than benign.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Something that seemed to be a warning.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hey, it’s a beautiful day,” she said aloud, and went into the bathroom, where she splashed her face with cold water.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Suddenly she was afraid to look up. Afraid to look in the mirror above the sink. If she looked into the mirror…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" Would someone else be looking back at her?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She had to look up, of course. She couldn’t remain in her bathroom forever, bent over the sink.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She looked up. And felt like a fool. There was nothing there but her own reflection.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She gave herself a shake, got ready quickly and left the house.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" And still…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" That sense of foreboding clung to her, like a gray mist, damp and chill against her flesh.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1e8bd84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter-03.vue
// module id = 75
// module chunks = 0